import { render, staticRenderFns } from "./ClaimNumberSsoDeepLink.vue?vue&type=template&id=5d824d84&scoped=true"
import script from "./ClaimNumberSsoDeepLink.vue?vue&type=script&lang=ts"
export * from "./ClaimNumberSsoDeepLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d824d84",
  null
  
)

export default component.exports